import { LevelPaths } from "./LevelPaths";
import { QuestBucket } from "./QuestBucket";

export const BucketOfLearnins = ({
  currentPaths = [],
  currentQuests = [],
  hasOutstandingStrictAssignment = false,
}) => {
  if (hasOutstandingStrictAssignment) {
    return null;
  }

  return (
    <>
      <LevelPaths currentPaths={currentPaths} />
      <QuestBucket currentQuests={currentQuests} />
    </>
  );
};
